import useAuthStore from '~/store/auth'

export default defineNuxtRouteMiddleware(() => {
  const { isSuperAdmin } = storeToRefs(useAuthStore())

  if (!isSuperAdmin.value) {
    return navigateTo({
      name: 'dashboard',
    })
  }
})
